<script>
    import {BASE_URL} from "../../../../constants/constants";

    export let img, projectTierData
    let imageUrl = img.data ? img.data.attributes.url : img.url
</script>

<div class="left relative">
    <figure class="relative">
        <img src={`${BASE_URL+imageUrl}`} alt="#">
        <span class="tier">{projectTierData ? projectTierData.tier_label : ""}</span>
    </figure>
</div>